// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");

function evt2str(strConsumer, evt) {
  return Curry._1(strConsumer, evt.target.value);
}

function evt2bool(boolConsumer, evt) {
  return Curry._1(boolConsumer, evt.target.checked);
}

function evt2click(clickConsumer, evt) {
  Curry._1(clickConsumer, {
        ctrl: evt.ctrlKey,
        alt: evt.altKey,
        shift: evt.shiftKey,
        left: evt.button === 0,
        middle: evt.button === 1,
        right: evt.button === 2
      });
}

exports.evt2str = evt2str;
exports.evt2bool = evt2bool;
exports.evt2click = evt2click;
/* No side effect */
